import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { FormCheckbox, FormTextField } from '../../../common/form';
import { SaveUserGroupDto } from '../../../common/PricePrgClient';
import { createUserGroup } from '../redux/userGroupSlices';
type Props = {
    closeDialog: () => void;
};

const schema: yup.SchemaOf<SaveUserGroupDto> = yup.object().shape({
    name: yup.string().max(60).required().label('Name'),
    description: yup.string().max(200).label('Description'),
    disableInactivateArticleEmails: yup.bool().default(false).label('Disable sendout inactive articles'),
    hideWarehouseBalance: yup.bool().default(false).label('Hide warehouse balance')
});

export const CreateUserGroupDialog = ({ closeDialog }: Props) => {
    const { control, handleSubmit } = useForm<SaveUserGroupDto>({
        resolver: yupResolver(schema)
    });

    const dispatch = useDispatch();

    const submit = (data: SaveUserGroupDto) => {
        dispatch(createUserGroup.request(data));
        closeDialog();
    };

    return (
        <Dialog open={true}>
            <DialogTitle>Create new User Group</DialogTitle>
            <DialogContent>
                {/*Todo: Check if it's possible to use Box as form */}
                <Box
                    component="form"
                    id="createUserGroupForm"
                    sx={{ display: 'flex', flexDirection: 'column' }}
                    onSubmit={handleSubmit(data => submit(data))}
                >
                    <FormTextField label="Name" name="name" control={control} />
                    <FormTextField label="Description" name="description" control={control} />
                    <FormCheckbox
                        label="No inactivated products emails"
                        name="disableInactivateArticleEmails"
                        control={control}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>Cancel</Button>
                <Button color="primary" type="submit" form="createUserGroupForm">
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};
